import React from "react";
import styles from './Spinner.module.scss'

const Spinner = (props) => {
  return (
    <div className={styles?.Wrapper}>
      <div className={styles?.Content}></div>
    </div>
  );
};

export default Spinner;
